import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

/**
 * Minimal merchant-branded header for public payer pages (invoice lookup,
 * invoice detail, payment preparation) — Design System §12 / Phase 10.
 * Purely presentational: the merchant name/logo it renders are passed in by
 * the host component from data it already loaded.
 */
@Component({
  selector: 'app-payer-header',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './payer-header.component.html',
  styleUrl: './payer-header.component.scss',
})
export class PayerHeaderComponent {
  @Input() merchantName: string | null = null;
  @Input() merchantLogoUrl: string | null = null;

  get initials(): string {
    if (!this.merchantName) {
      return 'P';
    }
    return this.merchantName
      .split(' ')
      .filter(Boolean)
      .slice(0, 2)
      .map((word) => word.charAt(0).toUpperCase())
      .join('');
  }
}
